var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),(_vm.plotly)?_c('div',[_c('Plotly',{attrs:{"data":_vm.plotly,"layout":_vm.layout,"display-mode-bar":false}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }